"use strict";

var _regeneratorRuntime = require("/opt/build/repo/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/opt/build/repo/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/opt/build/repo/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BufferTokenizer = void 0;

var peek_readable_1 = require("peek-readable");

var BufferTokenizer = /*#__PURE__*/function () {
  /**
   * Construct BufferTokenizer
   * @param buffer - Buffer to tokenize
   * @param fileInfo - Pass additional file information to the tokenizer
   */
  function BufferTokenizer(buffer, fileInfo) {
    _classCallCheck(this, BufferTokenizer);

    this.buffer = buffer;
    this.position = 0;
    this.fileInfo = fileInfo ? fileInfo : {};
    this.fileInfo.size = this.fileInfo.size ? this.fileInfo.size : buffer.length;
  }
  /**
   * Read buffer from tokenizer
   * @param buffer
   * @param options - Read behaviour options
   * @returns {Promise<number>}
   */


  _createClass(BufferTokenizer, [{
    key: "readBuffer",
    value: function () {
      var _readBuffer = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(buffer, options) {
        var _this = this;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(options && options.position)) {
                  _context.next = 4;
                  break;
                }

                if (!(options.position < this.position)) {
                  _context.next = 3;
                  break;
                }

                throw new Error('`options.position` must be equal or greater than `tokenizer.position`');

              case 3:
                this.position = options.position;

              case 4:
                return _context.abrupt("return", this.peekBuffer(buffer, options).then(function (bytesRead) {
                  _this.position += bytesRead;
                  return bytesRead;
                }));

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function readBuffer(_x, _x2) {
        return _readBuffer.apply(this, arguments);
      }

      return readBuffer;
    }()
    /**
     * Peek (read ahead) buffer from tokenizer
     * @param buffer
     * @param options - Read behaviour options
     * @returns {Promise<number>}
     */

  }, {
    key: "peekBuffer",
    value: function () {
      var _peekBuffer = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(buffer, options) {
        var offset, length, position, bytes2read;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                offset = 0;
                length = buffer.length;
                position = this.position;

                if (!options) {
                  _context2.next = 10;
                  break;
                }

                if (!options.position) {
                  _context2.next = 8;
                  break;
                }

                if (!(options.position < this.position)) {
                  _context2.next = 7;
                  break;
                }

                throw new Error('`options.position` can be less than `tokenizer.position`');

              case 7:
                position = options.position;

              case 8:
                if (Number.isInteger(options.length)) {
                  length = options.length;
                } else {
                  length -= options.offset || 0;
                }

                if (options.offset) {
                  offset = options.offset;
                }

              case 10:
                if (!(length === 0)) {
                  _context2.next = 12;
                  break;
                }

                return _context2.abrupt("return", Promise.resolve(0));

              case 12:
                position = position || this.position;

                if (!length) {
                  length = buffer.length;
                }

                bytes2read = Math.min(this.buffer.length - position, length);

                if (!((!options || !options.mayBeLess) && bytes2read < length)) {
                  _context2.next = 19;
                  break;
                }

                throw new peek_readable_1.EndOfStreamError();

              case 19:
                this.buffer.copy(buffer, offset, position, position + bytes2read);
                return _context2.abrupt("return", bytes2read);

              case 21:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function peekBuffer(_x3, _x4) {
        return _peekBuffer.apply(this, arguments);
      }

      return peekBuffer;
    }()
  }, {
    key: "readToken",
    value: function () {
      var _readToken = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(token, position) {
        var tv;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                this.position = position || this.position;
                _context3.prev = 1;
                tv = this.peekToken(token, this.position);
                this.position += token.len;
                return _context3.abrupt("return", tv);

              case 7:
                _context3.prev = 7;
                _context3.t0 = _context3["catch"](1);
                this.position += this.buffer.length - position;
                throw _context3.t0;

              case 11:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[1, 7]]);
      }));

      function readToken(_x5, _x6) {
        return _readToken.apply(this, arguments);
      }

      return readToken;
    }()
  }, {
    key: "peekToken",
    value: function () {
      var _peekToken = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(token) {
        var position,
            _args4 = arguments;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                position = _args4.length > 1 && _args4[1] !== undefined ? _args4[1] : this.position;

                if (!(this.buffer.length - position < token.len)) {
                  _context4.next = 3;
                  break;
                }

                throw new peek_readable_1.EndOfStreamError();

              case 3:
                return _context4.abrupt("return", token.get(this.buffer, position));

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function peekToken(_x7) {
        return _peekToken.apply(this, arguments);
      }

      return peekToken;
    }()
  }, {
    key: "readNumber",
    value: function () {
      var _readNumber = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(token) {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                return _context5.abrupt("return", this.readToken(token));

              case 1:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function readNumber(_x8) {
        return _readNumber.apply(this, arguments);
      }

      return readNumber;
    }()
  }, {
    key: "peekNumber",
    value: function () {
      var _peekNumber = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(token) {
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                return _context6.abrupt("return", this.peekToken(token));

              case 1:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function peekNumber(_x9) {
        return _peekNumber.apply(this, arguments);
      }

      return peekNumber;
    }()
    /**
     * @return actual number of bytes ignored
     */

  }, {
    key: "ignore",
    value: function () {
      var _ignore = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(length) {
        var bytesIgnored;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                bytesIgnored = Math.min(this.buffer.length - this.position, length);
                this.position += bytesIgnored;
                return _context7.abrupt("return", bytesIgnored);

              case 3:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function ignore(_x10) {
        return _ignore.apply(this, arguments);
      }

      return ignore;
    }()
  }, {
    key: "close",
    value: function () {
      var _close = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8);
      }));

      function close() {
        return _close.apply(this, arguments);
      }

      return close;
    }()
  }]);

  return BufferTokenizer;
}();

exports.BufferTokenizer = BufferTokenizer;